import {
	WISHLIST_CONTAINS_ITEM_CLASS,
	WISHLIST_DOES_NOT_CONTAIN_ITEM_CLASS,
	WISHLIST_IS_LOADED_CLASS,
	WISHLIST_ITEM_CLASS,
	WISHLIST_BUTTON_NO_IMAGE_SLIDER_CLASS,
} from './constants';

/**
 * @return {boolean} Whether or not this is a single product.
 */
export function isSingleProduct() {
	return document.body.classList.contains( 'single-product' );
}

/**
 * @return {boolean} Whether or not this is the wishlist page.
 */
export function isWishlistPage() {
	return document.body.classList.contains( 'qala-wishlist-page' );
}

/**
 * Get the correct class for a product.
 *
 * @param {number|string} productId Product ID
 * @param {Array}         list      The list of products in the Wishlist
 *
 * @return {string} The class name.
 */
export function getWishlistItemClass( productId, list ) {
	const isInList = list.includes( parseInt( productId ) );

	return ( isInList ) ? WISHLIST_CONTAINS_ITEM_CLASS : WISHLIST_DOES_NOT_CONTAIN_ITEM_CLASS;
}

/**
 * Get the classes of the containers.
 *
 * This is different depending on whether or not
 * we are looking at a single product or a product
 * archive.
 *
 * @return {string} The container ID.
 */
export function getContainerClasses() {
	return wp.hooks.applyFilters( 'qala_wishlist.filter.container_classes', [ '#content' ] );
}

/**
 * Toggle product classes after an AJAX action.
 *
 * @param {string} containerClasses The ID of the container.
 * @param {Array}  products         The products in the Wishlist.
 */
export function toggleProductClasses( containerClasses, products = [] ) {
	const containers = document.querySelectorAll( containerClasses );
	if ( ! containers ) {
		return;
	}

	containers.forEach( container => {
		const links = container.getElementsByClassName( WISHLIST_ITEM_CLASS );
		if ( ! links.length ) {
			return;
		}

		Array.from( links ).forEach( ( { dataset, classList } ) => {
			const { productId } = dataset;
			const className = getWishlistItemClass( productId, products );

			classList.remove( WISHLIST_DOES_NOT_CONTAIN_ITEM_CLASS );
			classList.remove( WISHLIST_CONTAINS_ITEM_CLASS );
			classList.add( WISHLIST_IS_LOADED_CLASS );
			classList.add( className );
		} );
	} );
}

/**
 * Check if images slider gallery exists on PDP.
 *
 * @return {boolean} If images slider gallery exists.
 */
export function productHasImagesSlider() {
	return !! document.querySelector( '.product-images-slider-container' );
}

/**
 * Add a class to imply that we are displaying wishlist button without images slider.
 */
export function addNoImageSliderClass() {
	const imageSliderWishlistButton = document.querySelector( `.product-gallery-wrap .${ WISHLIST_ITEM_CLASS }` );
	if ( imageSliderWishlistButton ) {
		imageSliderWishlistButton.classList.add( WISHLIST_BUTTON_NO_IMAGE_SLIDER_CLASS );
	}
}
